import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "../../../main/services";
import {TenderRevisionService} from "../../services";

@Component({
    selector: 'jft-revision-tab-model',
    templateUrl: './revision-tab-model.component.html',
    styleUrls: ['./revision-tab-model.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionTabModelComponent implements OnInit {
    @Input() public modelTab;

    @Input() public baseCurrencyCode;
    @Input() public baseUnitCode;
    @Input() public finalBaseAmount;
    @Input() public finalGap;
    @Input() public finalGapTotal;
    @Input() public currentContractsTotal;
    @Input() public totalVolume;
    @Input() public selectedContractsTotal;
    @Input() public selectedTotalVolume;
    @Input() public hasSelectedBids: boolean;

    @Output() onTabTextChange = new EventEmitter();

    constructor(
        private route: ActivatedRoute,
        protected toast: ToastService,
        private router: Router,
        private service: TenderRevisionService,
    ) {

    }

    ngOnInit(): void {
    }

    public modelTabTextChange(event){
        this.onTabTextChange.emit(event);
    }
}
